import React, {Component} from 'react';
import ReactDOM from 'react-dom';

import PropTypes from "prop-types";
import DottedLoader from "./DottedLoader";

class Loader extends Component {
  static propTypes = {
    type: PropTypes.string,
    overlay: PropTypes.bool
  };

  render() {
    let className = ["loader"];
    if (this.props.type) {
      className.push(this.props.type);
    } else {
      className.push("overlay");
    }

    let loader = (
      <div className={className.join(" ")}>
        <div className="lds-ring">
          <div />
          <div />
          <div />
          <div />
        </div>

        <DottedLoader />
      </div>
    );

    if (this.props.overlay) {
      return ReactDOM.createPortal(
        loader,
        document.body
      )
    }

    return loader;
  }
}

export default Loader;